module.exports = __webpack_public_path__ + "img/MK.e3658f78.svg";